<script setup>
import { Loc } from 'main.core';
</script>

<template>
  <h3 class="cloud-calculator__how-to-title">
    {{ Loc.getMessage('1CR_STSL_CLOUD_CALCULATOR_HOW_TO_TITLE') }}
  </h3>
</template>
